var _footerDisplayQuery;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { graphql, usePreloadedQuery } from "react-relay/hooks";
import { BaseFooter } from "~/components/base-footer";
import { useSdkContext } from "~/components/contexts";
export const FooterDisplay = ({
  queryReference,
  ...props
}) => {
  var _queryResponse$appCon, _newsletter$homepageD, _newsletter$homepageD2, _newsletter$summary$t, _newsletter$summary, _entityJson$config$en;
  const {
    config
  } = useSdkContext();
  const queryResponse = usePreloadedQuery(query, queryReference);
  const entityJson = (_queryResponse$appCon = queryResponse.appConfig) === null || _queryResponse$appCon === void 0 ? void 0 : _queryResponse$appCon.json;
  const newsletter = queryResponse.newsletter;
  return /*#__PURE__*/React.createElement(BaseFooter, _extends({}, props, {
    newsletterItems: [{
      alternativeName: newsletter.alternativeName,
      entityId: newsletter.entityId,
      homepageDescription: {
        text: (_newsletter$homepageD = (_newsletter$homepageD2 = newsletter.homepageDescription) === null || _newsletter$homepageD2 === void 0 ? void 0 : _newsletter$homepageD2.text) !== null && _newsletter$homepageD !== void 0 ? _newsletter$homepageD : ""
      },
      name: newsletter.name,
      summary: {
        text: (_newsletter$summary$t = (_newsletter$summary = newsletter.summary) === null || _newsletter$summary === void 0 ? void 0 : _newsletter$summary.text) !== null && _newsletter$summary$t !== void 0 ? _newsletter$summary$t : ""
      }
    }],
    printEditionFooterConfig: entityJson === null || entityJson === void 0 || (_entityJson$config$en = entityJson[config.environment]) === null || _entityJson$config$en === void 0 ? void 0 : _entityJson$config$en.print_edition_footer,
    "data-qa": "footer-display"
  }));
};
FooterDisplay.displayName = "FooterDisplay";
export const query = _footerDisplayQuery !== void 0 ? _footerDisplayQuery : (_footerDisplayQuery = require("../../../queries/__generated__/footerDisplayQuery.graphql"), _footerDisplayQuery.hash && _footerDisplayQuery.hash !== "88d7d054c9fb5b7bbe088e9d86c9ec22" && console.error("The definition of 'footerDisplayQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), _footerDisplayQuery);